module.exports = __webpack_public_path__ + "img/document.57ea86f8.png";